import { createFileRoute, redirect } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import LoginPage from "@/components/Login/LoginPage";

export const Route = createFileRoute("/login")({
  validateSearch: (search) =>
    search as {
      redirect?: string;
    },
  beforeLoad: async ({ context }) => {
    // redirect to index page (currentWorkspace determination) if session exists
    const session = await context.queryClient.ensureQueryData(authQueries.getAuthSession());
    if (session) {
      throw redirect({
        to: "/",
      });
    }
  },
  component: LoginPage,
});
